<template>
  <div class="row my-4">
    <!-- ===================== BUSCADOR ===================== -->
    <div
      v-if="
        !isReadOnly && !isAddMode && canAddProponents && !isRenewalOrAmendment
      "
      class="row col-12"
    >
      <div class="col-11 my-3">
        <custom-input
          v-model="ssnName"
          icon="fal fa-search color-primary-2"
          left-icon
          placeholder="SSN o Nombre del Proveedor"
          prepend-icon-type="success"
          @input="onSsnInput"
        />
      </div>
      <div v-if="!isReadOnly && !isAddMode" class="col-auto my-3">
        <action-button
          i="fal fa-search"
          text="Buscar"
          variant="success px-3"
          @click="searchByCriteria"
        />
      </div>
    </div>
    <!-- Formulario de añadir nuevo proveedor -->
    <div v-if="isAddMode && !isRenewalOrAmendment" class="col-12 my-3">
      <add-provider
        v-model="ssnName"
        @add="onAddNewContractor"
        @cancel="onToggleAddForm"
      />
    </div>

    <!-- ===================== Resultado a seleccionar  ===================== -->
    <div
      v-if="
        !isReadOnly && !isAddMode && canAddProponents && !isRenewalOrAmendment
      "
      class="col-12"
    >
      <custom-separator v-if="searchResult" class="my-4" text="Resultados" />

      <!-- selecionados -->
      <div
        v-for="row in filteredResults"
        :key="'res-' + row?.id"
        class="rounded p-3 bg-gray my-3 item-container"
      >
        <div class="row d-flex align-items-center">
          <div class="col-12 col-md-2">
            <div class="text-center border-right">
              <span
                class="badge badge-pill px-3 py-2 font-14"
                :style="{ '--item-status-color': color(row.status.id) }"
              >
                {{ row.status.name }}
              </span>
            </div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Nombre del Proponente:</div>
            <div class="font-weight-bold">
              {{ row.name | empty }}
            </div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Teléfono:</div>
            <div class="font-weight-bold">{{ row.phoneNumber | phone }}</div>
          </div>

          <div class="col-12 col-md">
            <div class="data-name">Correo Electrónico:</div>
            <custom-input v-model="row.email" disabled />
          </div>
          <div v-if="!isReadOnly" class="col-12 col-md-1 custom-pl">
            <div class="d-flex align-items-center justify-content-md-end h-100">
              <check-box
                class="row-check"
                :value="false"
                @input="() => onSelectResult(row)"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showNoResults"
        class="d-flex justify content-center flex-column align-items-center my-5"
      >
        <custom-result-not-found text="No se encontró Contratista." />

        <a
          v-if="showAddLink"
          class="text-green pointer"
          href="#"
          @click.prevent="onToggleAddForm"
        >
          <i class="fas fa-file-plus mr-2 " />
          Añadir Contratista
        </a>
      </div>
    </div>
    <div class="col-12">
      <custom-separator class="my-4" text="Seleccionados" />
    </div>
    <!-- Label -->
    <div class="row col-12 align-items-center">
      <div class="col-3">
        <i class="fas fa-user text-orange mr-2" />
        <strong class="text-muted">Proponentes</strong>
        <span class="badge custom-counter-bg text-white p-2 mx-2">
          {{ proponentsCounter }}
        </span>
      </div>
      <div class="col-9">
        <div v-if="showMinimumAlert" class="alert alert-warning" role="alert">
          <i class="fas fa-bell-exclamation mr-2" />
          <strong>
            {{ minimumProponentsAlertText }}
          </strong>
        </div>
      </div>
    </div>

    <!-- Proponentes que vienen del request -->
    <div class="col-12">
      <div
        v-for="item in visibleItems"
        :key="item.id"
        class="rounded p-3 bg-gray my-3 item-container"
      >
        <div class="row d-flex align-items-center">
          <div class="col-12 col-md-2">
            <div class="text-center border-right">
              <span
                class="badge badge-pill px-3 py-2 font-14"
                :style="{ '--item-status-color': color(item.status.id) }"
              >
                {{ item.status.name }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="data-name">Nombre del Proponente:</div>
            <div class="font-weight-bold">
              {{ item.name | empty }}
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="data-name">Teléfono:</div>
            <div class="font-weight-bold">{{ item.phoneNumber | phone }}</div>
          </div>
          <div class="col-12 col-md">
            <div class="data-name">Correo Electrónico:</div>
            <div class="d-flex align-items-center">
              <validation-provider
                :ref="`item-${item.id}`"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'El campo es requerido.',
                  email: 'El correo electrónico no es válido.',
                }"
                rules="required|email"
              >
                <custom-input
                  v-model="item.email"
                  :disabled="item.disabled"
                  :error="errors[0]"
                />
              </validation-provider>
              <div v-if="isPending(item.status.id)" class="ml-3">
                <action-button
                  :i="`fas fa-${item.disabled ? 'edit' : 'check'}`"
                  variant="success"
                  @click="setEmail(item)"
                />
              </div>
            </div>
          </div>
          <div
            v-if="!isReadOnly && !isRenewalOrAmendment"
            class="col-12 col-md-1 custom-pl"
          >
            <div class="d-flex align-items-center justify-content-md-end h-100">
              <check-box
                class="row-check"
                :value="item.checked"
                @input="(val) => onToggleSelected(item, val)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="canShowMore" class="col-12 d-flex justify-content-center my-3">
      <action-button
        variant="outline-success custom-view-more actionButton rounded-pill"
        @click="loadMore"
      >
        Ver más
        <i class="ml-1 fas fa-chevron-down" />
      </action-button>
    </div>
  </div>
</template>

<script>
import CheckBox from 'CheckBox';
import { ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import {
  getContractors,
  withContractAnnouncement,
} from '@/modules/purchaseService/api.js';
import determinationCategories from '@/utils/constants/purchaseServiceDeterminationCategories';
import { COLORS } from '@/utils/constants/proponentsStatuses';
import { match } from '@/utils/objUtils';
import AddProvider from '../../purchaseService/components/AddProvider.vue';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'Proponents',
  components: {
    ValidationProvider,
    ActionButton,
    CustomInput,
    CustomSeparator,
    CustomResultNotFound,
    AddProvider,
    CheckBox,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
    determinationCategoryId: {
      type: Number,
      default: () => 0,
    },
    estimatedAmount: {
      type: Number,
      default: () => 0,
    },
    minimumProponentsRequired: {
      type: Number,
      default: () => 1,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isRenewalOrAmendment: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      ssnName: '',
      isAddMode: false,
      searchDone: false,
      searchResult: null,
      tempIdCounter: -1,
      visibleCount: 3,
    };
  },
  computed: {
    visibleItems() {
      return this.items.slice(0, this.visibleCount);
    },

    canShowMore() {
      return this.items.length > this.visibleCount;
    },
    showAddLink() {
      return this.showNoResults && !this.isAddMode;
    },
    color() {
      return (isSubmitted) => match(isSubmitted, COLORS);
    },
    showNoResults() {
      return this.searchDone && !this.searchResult;
    },
    filteredResults() {
      if (!this.searchResult) return [];

      const exists = this.items.some((x) => x.id === this.searchResult.id);

      return exists ? [] : [this.searchResult];
    },
    isPending() {
      return (isSubmitted) => !isSubmitted;
    },

    selectedProponentsCount() {
      return this.items.length ?? 0;
    },
    isMinimumNotMet() {
      return (
        this.determinationCategoryId === determinationCategories.Quotation &&
        this.selectedProponentsCount < this.minimumProponentsRequired
      );
    },
    minimumProponentsAlertText() {
      if (this.determinationCategoryId !== determinationCategories.Quotation) {
        return 'Requieren un mínimo de 1 proponentes para poder enviar invitaciones.';
      }

      if (this.estimatedAmount > 10000 && this.estimatedAmount <= 100000) {
        return 'Costos de $10,000.01-$100,000.00 requieren un mínimo de 3 proponentes para poder enviar invitaciones.';
      }

      if (this.estimatedAmount > 100000 && this.estimatedAmount < 250000) {
        return 'Costos desde $100,000.01 pero menos de $250,000.00 requieren un mínimo de 5 proponentes para poder enviar invitaciones.';
      }

      return 'Requieren un mínimo de 1 proponentes para poder enviar invitaciones.';
    },

    showMinimumAlert() {
      return this.isMinimumNotMet;
    },
    proponentsCounter() {
      return `${this.selectedProponentsCount}/${this.minimumProponentsRequired}`;
    },
    canAddProponents() {
      return this.determinationCategoryId !== determinationCategories.RFP;
    },
  },
  watch: {
    items: {
      handler(newVal) {
        if (!Array.isArray(newVal)) return;

        newVal.forEach((item) => {
          if (typeof item.disabled === 'undefined') {
            this.$set(item, 'disabled', true);
          }
          if (typeof item.checked === 'undefined') {
            this.$set(item, 'checked', true);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    if (this.items?.length) return;
    await this.getProponents(this.id);
  },
  methods: {
    onToggleSelected(item, checked) {
      if (!checked) {
        const updatedItems = this.items.filter((x) => x.id !== item.id);
        this.$emit('update:items', updatedItems);
      }
    },
    loadMore() {
      this.visibleCount += 3;
    },
    generateTempId() {
      return this.tempIdCounter--;
    },
    async searchByCriteria() {
      this.searchDone = true;
      this.isAddMode = false;
      this.searchResult = null;

      try {
        const response = await withContractAnnouncement({
          ssn: this.isValidSsn ? this.ssnName : null,
          name: !this.isValidSsn ? this.ssnName : null,
        });

        const list = response?.data?.data ?? [];
        const first = list[0] || null;

        if (first) {
          this.searchResult = {
            ...first,
            checked: false,
            disabled: true,
            status: first.status ?? { name: 'Pendiente', id: false },
            name: first.name ?? '',
            phoneNumber: first.phoneNumber ?? '',
            email: first.email ?? '',
          };
        } else {
          this.searchResult = null;
        }
      } catch (e) {
        this.searchResult = null;
      }
    },
    onSelectResult(row) {
      this.$emit('update:items', [
        ...this.items,
        {
          ...row,
          isFromRequest: false,
          disabled: true,
          checked: true,
        },
      ]);

      this.searchResult = null;
      this.ssnName = '';
      this.searchDone = false;
    },
    onSsnInput() {
      this.searchDone = false;

      if (!this.ssnName || !this.ssnName.trim()) {
        this.searchResult = null;
        this.isAddMode = false;
      }
    },
    onToggleAddForm() {
      this.isAddMode = !this.isAddMode;
    },
    onAddNewContractor(newContractor) {
      const item = {
        ...newContractor,
        id: this.generateTempId(),
        checked: true,
        isSubmitted: false,
        purcharseContractorId: null,
        status: {
          id: false,
          name: 'Pendiente',
        },
        disabled: true,
        isFromRequest: false,
      };

      this.$emit('update:items', [...this.items, item]);

      this.isAddMode = false;
      this.searchDone = false;
      this.ssnName = '';
    },
    async getProponents() {
      const { data = [] } = await getContractors(this.id);
      const items = data.map((x) => ({ ...x, disabled: true }));
      this.$emit('update:items', items);
    },
    async setEmail(item) {
      if (!item.disabled) {
        const { valid } = await this.$refs[`item-${item.id}`][0].validate();
        if (!valid) return;
      }
      item.disabled = !item.disabled;
    },
    isValidSsn() {
      const pattern = /^\d{3}-\d{6}$/; // ej: 660-355157
      return pattern.test((this.ssnName || '').trim());
    },
  },
};
</script>
<style scoped lang="scss">
.badge {
  background-color: var(--item-status-color);
}

::v-deep .input-display label:last-child {
  font-weight: 700 !important;
}
.section-title__extended ::v-deep {
  .dot {
    background-color: #fff !important;
  }
}
.custom-counter-bg {
  background-color: #ff7058;
}
</style>
